(() => {
  const HUES = [32, 350, 105, 25, 195, 135, 15, 280, 330, 220];
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initMoodCards(scope = document) {
    scope.querySelectorAll('.ch-mood:not([data-ch-ready])').forEach((card, index) => {
      card.dataset.chReady = 'true';
      const activate = () => {
        document.documentElement.style.setProperty('--ch-active-hue', String(HUES[index % HUES.length]));
        document.querySelectorAll('.ch-mood.is-active').forEach((item) => item.classList.remove('is-active'));
        card.classList.add('is-active');
        const reading = document.querySelector('[data-mood-reading]');
        const title = card.querySelector('h3')?.textContent?.trim() || '';
        if (reading) reading.textContent = `MOOD ${String(index + 1).padStart(2, '0')} / ${title}`;
      };
      card.addEventListener('mouseenter', activate);
      card.addEventListener('focusin', activate);
    });
  }

  function initTilt(scope = document) {
    if (reduceMotion || window.Shopify?.designMode) return;
    scope.querySelectorAll('[data-ch-tilt]:not([data-ch-tilt-ready])').forEach((card) => {
      card.dataset.chTiltReady = 'true';
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        card.style.setProperty('--rx', `${-y * 4}deg`);
        card.style.setProperty('--ry', `${x * 5}deg`);
      });
      card.addEventListener('pointerleave', () => {
        card.style.setProperty('--rx', '0deg');
        card.style.setProperty('--ry', '0deg');
      });
    });
  }

  function initMaterialTabs(scope = document) {
    scope.querySelectorAll('[data-ch-material-tabs]:not([data-ch-tabs-ready])').forEach((tabs) => {
      tabs.dataset.chTabsReady = 'true';
      const buttons = [...tabs.querySelectorAll('[data-ch-tab]')];
      const panels = [...tabs.querySelectorAll('[data-ch-panel]')];
      buttons.forEach((button) => button.addEventListener('click', () => {
        buttons.forEach((item) => item.setAttribute('aria-selected', String(item === button)));
        panels.forEach((panel) => { panel.hidden = panel.dataset.chPanel !== button.dataset.chTab; });
      }));
    });
  }

  function init(scope = document) {
    initMoodCards(scope);
    initTilt(scope);
    initMaterialTabs(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:block:select', (event) => event.target?.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' }));
})();
